export const saveAuthStore = (state, { key, data: payload }) => state[key] = payload;

export const setMetricsUUID = (state, uuid) => {
  state.metrics.uuid = uuid;
  setCookie("metricsUUID", uuid, 1);
};

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export const clearReasonsPartnerAnwersAndMetric = (state) => {
  sessionStorage.removeItem('reasons');
  sessionStorage.removeItem('partner');
  sessionStorage.removeItem('answers');
  state.reasons = [];
  state.partner = [];
  state.answers = [];
  state.metrics = "";
}

export const clearReasonsPartnerAndAnwers = (state) => {
  sessionStorage.removeItem('reasons');
  sessionStorage.removeItem('partner');
  sessionStorage.removeItem('answers');
  state.reasons = [];
  state.partner = [];
  state.answers = [];
}

export const setClinicalNotesCryptoStatus = (state, status) => {
  state.clinicalNotesCryptoStatus = status ?? null
}

export const setClinicalNotesMasterKeyBytes = (state, bytes) => {
  if (bytes == null) {
    state.clinicalNotesMasterKeyBytes = null
    state.clinicalNotesUnlockDismissed = false
    return
  }
  state.clinicalNotesMasterKeyBytes = bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes)
  state.clinicalNotesUnlockDismissed = false
}

export const setClinicalNotesUnlockDismissed = (state, dismissed) => {
  state.clinicalNotesUnlockDismissed = Boolean(dismissed)
}

// Con cookies: solo user + timestamp de expiración (token no se guarda en cliente)
export const login = (state, { user, expires_in }) => {
  state.auth.token = null
  state.auth.user = user

  if (expires_in != null) {
    const currentSeconds = Math.floor(Date.now() / 1000)
    const expirationTimestamp = currentSeconds + Number(expires_in)
    state.auth.tokenExpiresIn = expirationTimestamp
    localStorage.setItem('token_expires_in', expirationTimestamp)
  }

  if (user) {
    localStorage.setItem('user', JSON.stringify(user))
  }
}

export const logout = (state) => {
  state.auth = {}
  state.clinicalNotesCryptoStatus = null
  state.clinicalNotesMasterKeyBytes = null
  state.clinicalNotesUnlockDismissed = false
  sessionStorage.removeItem('profile-flow')
  localStorage.removeItem('token')
  localStorage.removeItem('token_expires_in')
  localStorage.removeItem('user')
  sessionStorage.removeItem('token')
  sessionStorage.removeItem('user')
}

export const updateInformedConsent = (state, informed_concent) => {
  if (state.auth.user) {
    state.auth.user.accept_informed_consent = informed_concent
    localStorage.setItem('user', JSON.stringify(state.auth.user))
  }
}

export const setTokenExpiresIn = (state, expires_in) => {
  if (expires_in != null) {
    const currentSeconds = Math.floor(Date.now() / 1000)
    const expirationTimestamp = currentSeconds + Number(expires_in)
    state.auth.tokenExpiresIn = expirationTimestamp
    localStorage.setItem('token_expires_in', expirationTimestamp)
  } else {
    state.auth.tokenExpiresIn = null
    localStorage.removeItem('token_expires_in')
  }
}

// Mantener por compatibilidad con refresh/verify-token; ya no guarda token
export const updateToken = (state, { expiresIn }) => {
  state.auth.token = null
  if (expiresIn != null) {
    const currentSeconds = Math.floor(Date.now() / 1000)
    const expirationTimestamp = currentSeconds + Number(expiresIn)
    state.auth.tokenExpiresIn = expirationTimestamp
    localStorage.setItem('token_expires_in', expirationTimestamp)
  }
}

export const setIsFamilyRoute = (state, isFamilyRoute) => {
  state.isFamilyRoute = isFamilyRoute;
}

export const setBrowserTimezone = (state, timezone) => {
  state.auth.timezone = timezone
}

// Compatibilidad con guard verifyTokenRecoverPassword (recuperación de contraseña)
export const clearPasswordResetToken = () => {}